var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hearingAidSales__location-summary" }, [
    _c("div", { staticClass: "sales-report__wrapper" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "location-summary--table-wrapper" }, [
        _c(
          "table",
          { staticClass: "location-summary__table" },
          [
            _c(
              "tr",
              [
                _c(
                  "td",
                  { staticClass: "table-field--chart" },
                  [
                    _c("LocationSummaryLegend", {
                      attrs: {
                        location: _vm.biggestLocation,
                        max: _vm.biggestLocation.totals.units,
                        min: _vm.chartMin
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.validLocations, function(location) {
                  return _c(
                    "td",
                    [
                      _c("LocationSummaryChart", {
                        attrs: {
                          location: location,
                          axis: false,
                          max: _vm.biggestLocation.totals.units,
                          min: _vm.chartMin
                        }
                      })
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.extraLocations, function(location) {
                  return _c("td", [_vm._v(" ")])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tr",
              [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _vm._l(_vm.validLocations, function(location) {
                  return _c(
                    "td",
                    {
                      key: location.location_id,
                      staticClass: "table-field--name"
                    },
                    [_vm._v(_vm._s(location.name))]
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.extraLocations, function(location) {
                  return _c("td", [_vm._v(" ")])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("TableRow", {
              attrs: {
                "valid-locations": _vm.validLocations,
                "extra-locations": _vm.extraLocations,
                title: "Premium",
                "location-property": "premium_units"
              }
            }),
            _vm._v(" "),
            _c("TableRow", {
              attrs: {
                "valid-locations": _vm.validLocations,
                "extra-locations": _vm.extraLocations,
                title: "Advanced",
                "location-property": "advanced_units"
              }
            }),
            _vm._v(" "),
            _c("TableRow", {
              attrs: {
                "valid-locations": _vm.validLocations,
                "extra-locations": _vm.extraLocations,
                title: "Basic",
                "location-property": "basic_units"
              }
            }),
            _vm._v(" "),
            _c("TableRow", {
              attrs: {
                "valid-locations": _vm.validLocations,
                "extra-locations": _vm.extraLocations,
                title: "Entry",
                "location-property": "entry_units"
              }
            }),
            _vm._v(" "),
            _c("TableRow", {
              attrs: {
                "valid-locations": _vm.validLocations,
                "extra-locations": _vm.extraLocations,
                title: "CROS",
                "location-property": "cros_units"
              }
            }),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "total-row" },
              [
                _vm._m(1),
                _vm._v(" "),
                _vm._l(_vm.validLocations, function(location) {
                  return _c("td", { key: location.location_id }, [
                    _vm._v(_vm._s(location.totals.units))
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.extraLocations, function(location) {
                  return _c("td", [_vm._v(" ")])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "total-row" },
              [
                _vm._m(2),
                _vm._v(" "),
                _vm._l(_vm.validLocations, function(location) {
                  return _c("td", { key: location.location_id }, [
                    _vm._v("$" + _vm._s(_vm.currency(location.totals.sales)))
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.extraLocations, function(location) {
                  return _c("td", [_vm._v(" ")])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "total-row" },
              [
                _vm._m(3),
                _vm._v(" "),
                _vm._l(_vm.validLocations, function(location) {
                  return _c("td", { key: location.location_id }, [
                    _vm._v(
                      "$" +
                        _vm._s(
                          _vm.currency(
                            _vm.divide(
                              location.totals.sales,
                              location.totals.units
                            )
                          )
                        )
                    )
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.extraLocations, function(location) {
                  return _c("td", [_vm._v(" ")])
                })
              ],
              2
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "css-grid sales-report__header" }, [
      _c("div", { staticClass: "sales-report__header-name" }, [
        _c("div", [_vm._v("Locations Summary")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("div", { staticClass: "grid" }, [
        _c("div", { staticClass: "grid__col--12 total-col h-right-align" }, [
          _vm._v("TOTAL UNITS")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("div", { staticClass: "grid" }, [
        _c("div", { staticClass: "grid__col--12 total-col h-right-align" }, [
          _vm._v("TOTAL SALES")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("div", { staticClass: "grid" }, [
        _c("div", { staticClass: "grid__col--12 total-col h-right-align" }, [
          _vm._v("ASP")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }